import { render } from "./vue-custom-input-component.vue?vue&type=template&id=5a7461a3"
import script from "./vue-custom-input-component.vue?vue&type=script&lang=js"
export * from "./vue-custom-input-component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\users\\siste\\source\\repos\\dilsistemas\\Dil_Pagina\\Dil_Pagina\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__